import React from "react";
import HeaderWithSearch from "./HeaderWithSearch";
import ImageWithFallback from "./ImageWithFallback";

function Pop() {
  return (
    <>
      <HeaderWithSearch />
      <main style={{
        minHeight: "100vh",
        width: "100%",
        background: "linear-gradient(180deg, #e3f0fc 0%, #fafdff 100%)",
        padding: 0,
        margin: 0
      }}>
        <section style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "60vh",
          padding: "60px 0 40px 0"
        }}>
          <h1 style={{ fontSize: "3rem", fontWeight: "bold", marginBottom: 12 }}>Pop Songs</h1>
          <p style={{ fontSize: "1.3rem", color: "#333", marginBottom: 32 }}>Popular English piano covers.</p>
          <div style={{ display: "flex", justifyContent: "center", gap: 48, margin: "40px 0 80px 0", flexWrap: "wrap" }}>
            <a href="/senorita" style={{ textDecoration: "none", color: "inherit" }}>
              <div style={{ background: "#fff", borderRadius: 18, boxShadow: "0 2px 16px rgba(0,0,0,0.07)", padding: 24, width: 260, textAlign: "center", transition: "transform 0.2s", cursor: "pointer" }}>
                <ImageWithFallback src="/Senorita.png" alt="Senorita" style={{ width: 120, height: 120, objectFit: "cover", marginBottom: 16, borderRadius: 12 }} />
                <h3 style={{ fontSize: "1.3rem", fontWeight: 600 }}>Senorita</h3>
              </div>
            </a>
            <a href="/believer" style={{ textDecoration: "none", color: "inherit" }}>
              <div style={{ background: "#fff", borderRadius: 18, boxShadow: "0 2px 16px rgba(0,0,0,0.07)", padding: 24, width: 260, textAlign: "center", transition: "transform 0.2s", cursor: "pointer" }}>
                <ImageWithFallback src="/Beliver.png" alt="Believer" style={{ width: 120, height: 120, objectFit: "cover", marginBottom: 16, borderRadius: 12 }} />
                <h3 style={{ fontSize: "1.3rem", fontWeight: 600 }}>Believer</h3>
              </div>
            </a>
            <a href="/letmedownslowly" style={{ textDecoration: "none", color: "inherit" }}>
              <div style={{ background: "#fff", borderRadius: 18, boxShadow: "0 2px 16px rgba(0,0,0,0.07)", padding: 24, width: 260, textAlign: "center", transition: "transform 0.2s", cursor: "pointer" }}>
                <ImageWithFallback src="/Let_me_down_slowly.png" alt="Let Me Down Slowly" style={{ width: 120, height: 120, objectFit: "cover", marginBottom: 16, borderRadius: 12 }} />
                <h3 style={{ fontSize: "1.3rem", fontWeight: 600 }}>Let Me Down Slowly</h3>
              </div>
            </a>
            <a href="/shapeofyou" style={{ textDecoration: "none", color: "inherit" }}>
              <div style={{ background: "#fff", borderRadius: 18, boxShadow: "0 2px 16px rgba(0,0,0,0.07)", padding: 24, width: 260, textAlign: "center", transition: "transform 0.2s", cursor: "pointer" }}>
                <ImageWithFallback src="/Shape_of_you.png" alt="Shape of You" style={{ width: 120, height: 120, objectFit: "cover", marginBottom: 16, borderRadius: 12 }} />
                <h3 style={{ fontSize: "1.3rem", fontWeight: 600 }}>Shape of You</h3>
              </div>
            </a>
          </div>
        </section>
      </main>
    </>
  );
}

export default Pop;
